__turbopack_context__.v({
  "container": "SearchResults-module__jRBQ3a__container",
  "pageTitle": "SearchResults-module__jRBQ3a__pageTitle",
  "section": "SearchResults-module__jRBQ3a__section",
  "sectionTitle": "SearchResults-module__jRBQ3a__sectionTitle",
});
